import { StoreDisplayGroupFilters } from '../types/storeDisplayGroup';
// 修改引用路径
import { VALIDATION_RULES } from './validationRules';

// Validation functions for form inputs
export const validateSearchInput = (value: string): string | null => {
  if (!value) return null;
  
  if (value.length > VALIDATION_RULES.SEARCH_MAX_LENGTH) {
    return VALIDATION_RULES.SEARCH_LENGTH_MESSAGE;
  }
  
  return null;
};

// Sanitize search input to prevent XSS
export const sanitizeSearchInput = (value: string): string => {
  return value.replace(/[<>\"'&]/g, '');
};

// Validate filter parameters
export const validateFilters = (filters: StoreDisplayGroupFilters): boolean => {
  // Check if search input is valid
  if (filters.search && validateSearchInput(filters.search)) {
    return false;
  }
  
  return true;
};

// Format display values
export const formatBindedShelfCount = (bound: number): string => {
  return bound ? `${bound}` : '-';
};

export const formatSkuRange = (min: number, max: number): string => {
  return `${min}-${max}`;
};

// Generate trace ID for API requests (mock implementation)
export const generateTraceId = (): string => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};